const moment = require('moment')
const fs = require('fs')
const shell = require('shelljs')
const path = require('path')
const chalk = require('chalk')
const strip = require('strip-ansi')
const XLSX = require('xlsx')
const { every } = require('lodash')
const home = process.env.HOME
const htmlToPdf = require('html-pdf')
const templateGenerator = require('templates/timecard')

const {
	begin, finish, warn, error,
	inquirer, config, newline,
	primary, accent, danger,
	configFileName
} = require('../common.js')

const configTimecardDefault = {
	constants: {
		picture: 'Avatar Sequels',
		work_city: 'MB',
		work_state: 'CA',
		ssn_last_4: 'XXXX',
		union: 'NON',
		account_num: 'X',
		mileage_account_num: '147-44-001',
		occupation: 'Content Developer'
	},
	data: {}
}

const workedValue = 'WORKED'

const HOME_PATH = process.env.HOME

let force
let print
let timecard
let offset = 0

module.exports = yargs => {

	const argv = yargs
		.reset()
		.option("force", {
			alias: "f",
			description: "command will assume no off days during the week."
		})
		.option("print", {
			alias: "p",
			description: "command will print the file."
		})
		.option("edit", {
			alias: "e",
			description: "open the raw timecard data in a text editor."
		})
		.option("reset", {
			alias: "r",
			description: "command reset existing timecard config (data will be preserved)."
		})
		.option("offset", {
			alias: "o",
			description: "generate a timecard with dates offset by a specified number of days"
		})
		.argv

	force = argv.force
	print = argv.print
	offset = argv.offset

	begin('timecard')

	if (argv.reset) 
	{
		config.set('timecard', configTimecardDefault)
		console.log("\treset timecard constants and data.")
		finish()

	} 
	else if (argv.edit) 
	{
		console.log("\topening raw timecard.")
		const editor = config.get("preferred_editor")
		const configPath = path.resolve(HOME_PATH, configFileName)
		shell.exec(`open -a "${editor}" ${configPath}`)
		finish()
	} 
	else 
	{
		_readTimecard()
	}


}

function _readTimecard() {

	timecard = timecard || config.get('timecard') || configTimecardDefault
	const configured = every(timecard.constants, val => !!val)

	if (configured) 
	{
		_getWorkWeekData()
	} 
	else 
	{

		console.log("\tmissing timecard fields")

		const choices = [
			'import existing timecard xlsx',
			'manually input values'
		]

		inquirer
			.prompt([{
				type: 'list',
				name: 'getFieldsMethod',
				message: 'how would you like to fill them in?',
				choices
			}])
			.then(({ getFieldsMethod }) => {

				newline()

				if (getFieldsMethod === choices[0])
					_importTimecard()
				else if (getFieldsMethod === choices[1])
					_inputTimecardData()

			})

	}

}

function _importTimecard() {

	inquirer
		.prompt([{
			type: 'input',
			name: 'filepath',
			message: `path to timecard:\n\t${HOME_PATH}/`
		}])
		.then(({ filepath }) => {

			const timecardPath = path.join(HOME_PATH, filepath)

			if (fs.existsSync(timecardPath)) {

				_parseTimecard(timecardPath)
				newline()
				_getWorkWeekData()

			} else {
				warn("\tcould not a file on that path,")
				warn("\tplease try another.\n")
				_importTimecard()
			}

		})

}

function _parseTimecard(timecardPath) {

	let errors

	try 
	{
		const workbook = XLSX.readFile(timecardPath, { type: "file" })
		const firstName = workbook.SheetNames[0]
		const firstSheet = workbook.Sheets[firstName]

		// get constants

		const CONFIG_ADRESSES = {
			picture: 'A3',
			work_city: 'AB3',
			work_state: 'AD3',
			ssn_last_4: 'K5',
			union: 'R5',
			account_num: 'U5',
			mileage_account_num: 'P27',
			occupation: 'AB7'
		}

		Object.keys(timecard.constants).forEach(field => {


			let value = firstSheet[CONFIG_ADRESSES[field]].v
			if (field === 'ssn_last_4' && value) value = String(value)
			if (field === 'mileage_account_num' &&
				!/^\d{3}-\d{2}-\d{3}$/.test(value)) value = null

			timecard.constants[field] = value ||
				configTimecardDefault.constants[field]
		})

		// get hours worked data

		const WEEK_END_ADDRESS = 'U3'
		const DAY_ADDRESSES = [
			'E10',
			'E12',
			'E14',
			'E16',
			'E18',
			'E20',
			'E22'
		]

		workbook.SheetNames.forEach(name => {
			const sheet = workbook.Sheets[name]
			const weekEndString = sheet[WEEK_END_ADDRESS].w
			const weekEndFormat = 'M/D/YY'

			const date = moment(weekEndString, weekEndFormat)
				.endOf('week')
				.startOf('day')

			timecard.data[date.format('MM DD YY')] = {
				timestamp: date.valueOf(),
				days: DAY_ADDRESSES
					.map(cell => sheet[cell] ?
						sheet[cell].v === 8 ? 
							workedValue : 
							sheet[cell].v : 
						null
					 )
					 .map(val => typeof val === 'string' ? 
						val.toUpperCase() : 
						null
					)
				}

		})

	} 
	catch (err) 
	{
		errors = true
		config.unset('timecard_path')

		console.log(danger('ops timecard error --'))
		newline()
		console.log(`\ttimecard at path ${timecardPath} is undreadable.`)
		console.log(`\tplease check the path and timecard file, then try again.`)
		newline()

		process.exit()

	}


}

function _inputTimecardData() {

	const prompts = Object.keys(timecard.constants).map(field => ({
		type: 'input',
		name: field,
		message: field.replace(/_/g, ' ') + ':',
		default: timecard.constants[field]
	}))

	inquirer
		.prompt(prompts)
		.then(answers => {
			timecard.constants = { ...answers }
			newline()
			console.log(accent("\ttimecard updated."))
			newline()
			_readTimecard()
		})

}

function _getWorkWeekData() {

	const endOfWeek = moment()
		.endOf('week')
		.startOf('day')
		.add(offset, 'week')

	const dayNameLength = 10
	const weekDays = [
		'monday',
		'tuesday',
		'wednesday',
		'thursday',
		'friday'
	]

	const weekDayDates = [
		moment()
			.startOf('week')
			.add(offset, 'week')
			.add(1, 'day'),
		moment()
			.startOf('week')
			.add(offset, 'week')
			.add(2, 'day'),
		moment()
			.startOf('week')
			.add(offset, 'week')
			.add(3, 'day'),
		moment()
			.startOf('week')
			.add(offset, 'week')
			.add(4, 'day'),
		moment()
			.startOf('week')
			.add(offset, 'week')
			.add(5, 'day')
	]

	if (force)
	{

		const resolvedData = {
			timestamp: endOfWeek.valueOf(),
			days: [
				null,
				workedValue,
				workedValue,
				workedValue,
				workedValue,
				workedValue,
				null,
			]
		}

		timecard.data[endOfWeek.format('MM DD YY')] = resolvedData

		_renderTimecard({
			data: resolvedData,
			constants: timecard.constants,
			name: config.get('name')
		})

	}
	else
	{
		const choices = [
			accent('worked'),
			accent('holiday'),
			chalk.yellow('sick'),
			chalk.gray('off')
		]

		const generateMessage = (day, idx) => (
			`${
				chalk.gray(weekDayDates[idx].format('MM DD'))
			}  ${
				day
			}${
				" ".repeat(dayNameLength - day.length)
			}`
		)

		const prompts = weekDays.map((day, idx) => ({
			type: 'list',
			name: day,
			message: generateMessage(day, idx),
			choices
		}))

		inquirer.prompt(prompts).then(data => {

			const resolvedData = {
				timestamp: endOfWeek.valueOf(),
				days: [
					null,
					...weekDays.map(day => strip(data[day]).toUpperCase()),
					null,
				]
			}

			timecard.data[endOfWeek.format('MM DD YY')] = resolvedData

			_renderTimecard({
				data: resolvedData,
				constants: timecard.constants,
				name: config.get('name')
			})

		})

	}

}

function _renderTimecard({ data, constants, name }) {
	

	const html = templateGenerator({ data, constants, name })
	const options = {
		"type": "png",
		"quality": "300",
		"width": "10.5in",
		"height": "8in",
		"zoomFactor": "1"
	}

	const renderedTimecard = htmlToPdf.create(html, options)

	_getShouldPrint()
		.then(shouldPrint => shouldPrint ?
			_printTimecard(renderedTimecard) :
			_writeTimecardFile(renderedTimecard, data.timestamp)
		)
		.then(_finish)
		.catch(err => {
			error('timecard', err)
			_finish()
		})




}

function _getShouldPrint() {
	return new Promise((resolve) => {

		if (print || force)
			resolve(true)
		else
		{
			newline()
			inquirer
				.prompt([{
					type: 'confirm',
					name: 'shouldPrint',
					message: 'print timecard?'
				}])
				.then(({ shouldPrint }) => { resolve(shouldPrint) })
		}

	})
}

function _printTimecard(renderedTimecard) {
	return new Promise((resolve, reject) => {
		newline()
		console.log('\tprinting...')

		// write file to tmp folder, then remove
		const path = `/tmp/ops_dev_cli_${moment().valueOf()}_print_job.png`

		renderedTimecard.toFile(path, (err, buffer) => {
			if (err)
			{
				reject('print error')
				return
			}

			try
			{
				shell.exec(`lpr ${path} -r`)
				console.log('\tdone\n')
				resolve()
			}
			catch (err)
			{
				console.error(err)
				reject('print error')
			}

		})
	})
}

function _writeTimecardFile(renderedTimecard, timestamp) {
	return new Promise((resolve, reject) => {
		newline()
		console.log('\tsaving to desktop...')

		const name = config.get('name').last.toLowerCase()
		const date = moment(timestamp).format("MM_DD_YY")
		const path = `${home}/Desktop/${name}_timecard_${date}.png`

		renderedTimecard.toFile(path, (err, res) => {
			if (err)
			{
				reject('could not save timecard to desktop')
			}
			else
			{
				console.log('\tdone\n')
				resolve()
			}

		})
	})
}


function _finish() {

		config.set('timecard', timecard)
		finish()

}



// WEBPACK FOOTER //
// ./src/commands/timecard.js